import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useEditUserInfoMutation, useGetUserInfoQuery } from "./api/userInfoApiSlice"
import UserImage from "components/commons/UserImage"

const EditUserInfo = () => {

    const [t, i18n] = useTranslation(["global"])
    const apiUrl = process.env.REACT_APP_API_URL

    const [
        sendRequest, {
            data: editResult,
            isLoading: editIsLoading,
            isSuccess: editSuccess,
            reset: editReset
        }
    ] = useEditUserInfoMutation()

    const {
        data: userProfile,
        isFetching: userIsFetching,
        isSuccess: userIsSuccess,
        isError: userIsError,
        error: userError
    } = useGetUserInfoQuery()


    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [username, setUsername] = useState('')
    const [pwd, setPwd] = useState(null)
    const [email, setEmail] = useState('')
    const [resetPwd, setResetPwd] = useState(false)
    const [userImage, setUserImage] = useState(null);

    /*     useEffect(() => {
            if (firstname != "" && lastname != "")
                setUsername(firstname.substring(0, 4).toLowerCase() + capitalizeFirstLetter(lastname.substring(0, 4)))
        }, [firstname, lastname]) */

    useEffect(() => {
        if (userIsSuccess) {
            setFirstname(userProfile.user.name)
            setLastname(userProfile.user.surname)
            setUsername(userProfile.user.username)
            setEmail(userProfile.user.email)
        }

    }, [userIsSuccess])


    const handleFirstnameInput = (e) => setFirstname(e.target.value)
    const handleLastnameInput = (e) => setLastname(e.target.value)
    const handleUsernameInput = (e) => setUsername(e.target.value)
    const handlePwdInput = (e) => setPwd(e.target.value)
    const handleEmailInput = (e) => setEmail(e.target.value)
    const handleImageChange = (event) => {
        setUserImage(event.target.files[0]);
    };


    const handleSubmit = async (e) => {
        e.preventDefault()

        const payload = {
            user: {
                username: username,
                name: firstname,
                surname: lastname,
                email: email
            },
            newPassword: pwd
        }

        const formData = new FormData();
        formData.append('userEditDto', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
        formData.append('image', userImage);


        console.log("Payload: " + JSON.stringify(payload))
        sendRequest(formData)

    }

    let content;


    if (userIsSuccess) {


        content = (
            <>
                <div className="row">

                    {
                        editSuccess === true &&
                        <>
                            <div>
                                <div className="alert alert-success alert-dismissible" role="alert" key="unique">
                                    {t("global:helper.edit_success")}
                                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            </div>

                        </>
                    }
                    <div className="col-md-8 order-md-1">

                        <form onSubmit={handleSubmit}>
                            <div className="row">

                                <h4 className="mb-3"><i className="fa-solid fa-user"></i> {t("menu.user_info")}</h4>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="employeeFirstName">{t("property.firstname")}</label>
                                    <input type="text" className="form-control" id="employeeFirstName" onChange={handleFirstnameInput} value={firstname} placeholder="" required />
                                    <div className="invalid-feedback">
                                        Valid first name is required.
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="lastName">{t("property.lastname")}</label>
                                    <input type="text" role="presentation" className="form-control" id="employeeLastName" onChange={handleLastnameInput} value={lastname} placeholder="" required />
                                    <div className="invalid-feedback">
                                        Valid last name is required.
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="username">{t("property.username")}</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">@</span>
                                    </div>
                                    <input type="text" className="form-control " id="employeeUsername" onChange={handleUsernameInput} value={username} disabled required />
                                    <div className="invalid-feedback">
                                        Your username is required.
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="email">{t("property.email")} <span className="text-muted">({t("property.optional")})</span></label>
                                <input type="email" className="form-control" id="email" onChange={handleEmailInput} value={email} placeholder="you@example.com" />
                                <div className="invalid-feedback">
                                    Please enter a valid email address for shipping updates.
                                </div>
                            </div>

                            <hr className="mb-3" />
                            <div className="row mb-3">
                                <UserImage guid={userProfile.user.guid} size={96}/>

                                <div className="col-md-6 mb-3">
                                    <label htmlFor="lastName"><i className="fa-solid fa-image"></i> Change Avatar</label><br />
                                    <input type="file" onChange={handleImageChange} accept="image/*" />
                                    <div className="invalid-feedback">
                                        Valid last name is required.
                                    </div>
                                </div>
                            </div>

                            <hr className="mb-3" />
                            <div className="mb-3">
                                <label htmlFor="password" >{t("property.password")}</label>
                                {
                                    resetPwd ? <>
                                        <input type="password" autocomplete="new-password" className="form-control" id="password" onChange={handlePwdInput} value={pwd} placeholder="" required />
                                        <div className="invalid-feedback">
                                            Please enter your shipping address.
                                        </div></>
                                        : <><br /><button className="btn mb-3 btn-warning" onClick={() => setResetPwd(true)}><i className="fa-solid fa-wrench"></i> {t("helper.reset_password")}</button></>
                                }
                            </div>

                            <hr className="mb-3" />

                            <button className="btn mb-3 btn-primary btn-lg btn-block"><i className="fa-solid fa-floppy-disk"></i> {t("action.save")}</button>

                        </form>
                    </div>
                </div>

            </>
        )
    }


    return <PageLayout
        pageTitle={t("menu.my_profile_edit")}
        isLoadingContent={editIsLoading}
        isLoadingPage={userIsFetching}
        bodyContent={
            content
        }
    />
}

export default EditUserInfo